'use client';

import { useEffect } from 'react';

export default function ChunkErrorHandler() {
  useEffect(() => {
    const handleError = (event: ErrorEvent) => {
      if (
        event.message &&
        (event.message.includes('ChunkLoadError') ||
          event.message.includes('Loading chunk') ||
          event.message.includes('failed to fetch dynamically imported module'))
      ) {
        event.preventDefault();
        window.location.reload();
      }
    };

    const handleUnhandledRejection = (event: PromiseRejectionEvent) => {
      const reason = event.reason;
      if (
        reason &&
        (reason.name === 'ChunkLoadError' ||
          (reason.message &&
            (reason.message.includes('ChunkLoadError') ||
              reason.message.includes('Loading chunk') ||
              reason.message.includes('failed to fetch dynamically imported module'))))
      ) {
        event.preventDefault();
        window.location.reload();
      }
    };

    window.addEventListener('error', handleError);
    window.addEventListener('unhandledrejection', handleUnhandledRejection);

    return () => {
      window.removeEventListener('error', handleError);
      window.removeEventListener('unhandledrejection', handleUnhandledRejection);
    };
  }, []);

  return null;
}
